import {faCommentAltLines} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import {useDomainConfig} from '../../provider/domain-config/domain-config-hook';

import * as styles from './pinomap-telegram-chat-button.scss';

export function PinomapTelegramChatButton(): JSX.Element | null {
    const {domainName} = useDomainConfig();

    if (domainName !== 'app.pinomap.com') {
        return null;
    }

    return (
        <Button
            aria-label="Telegram"
            className={styles.PinomapTelegramChatButton}
            href="https://t.me/Pino_Map "
            icon={<FontAwesomeIcon className={styles.PinomapTelegramChatButton_icon} icon={faCommentAltLines} />}
            rel="noreferrer"
            target="_blank"
        />
    );
}
